export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9086.feed6d25.jpg";